import ErrorMessages from "./data.json";

interface HttpErrorMessageDictionary {
    [path: string]: HttpErrorMessageDictionary | string;
}

export function getMessageKeyFromRequestUrl(url: string, error_code: string | number) {
    const REQ_URL = new URL(url);
    return (
        REQ_URL.pathname
            .slice(1)
            .split("/")
            // Mongo regex
            // .filter(it => /^[0-9a-fA-F]{24}$/.test(it) !== true)
            // Ulid regex
            .filter(
                it => /^[a-zA-Z]{1,6}_[0123456789ABCDEFGHJKMNPQRSTVWXYZ]{26}$/.test(it) !== true
            )
            .filter(it => /^[0-9]{6}$/.test(it) !== true)
            .join(".") +
        "." +
        error_code.toString()
    );
}

export function messageExists(path: string) {
    return getNestedObjProperty(ErrorMessages, path) !== null;
}
export function getMessage(path: string) {
    const t = getNestedObjProperty(ErrorMessages, path);
    return t === null ? path : t;
}
export function getNestedObjProperty(obj: HttpErrorMessageDictionary, property: string) {
    let wo = obj;
    const SPL_PROP = property.split(".");

    for (let i = 0; i < SPL_PROP.length; i++) {
        if (!wo.hasOwnProperty(SPL_PROP[i])) {
            return null;
        }
        const PROP = wo[SPL_PROP[i]];
        if (typeof PROP == "string") {
            return PROP;
        }
        wo = PROP;
    }

    return null;
}
